import { render, staticRenderFns } from "./AppForm.vue?vue&type=template&id=c156a594"
import script from "./AppForm.vue?vue&type=script&lang=ts"
export * from "./AppForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@neverendingsupport+vue2@2.7.22-template-compiler_css-loader@6.8.1_w_ce42a89a63fed7fe3b0df6fbe65086c7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports